import React, { useState } from 'react';
// import { Instagram, Linkedin, Twitter, Facebook, Plus } from 'lucide-react';
import { Linkedin, Plus } from 'lucide-react';

import Logo from "@/assets/desktopLogo.png"
import { Link } from 'react-router-dom';

interface Section {
    id: string;
    title: string;
    links: { text: string; href: string; }[];
}

const Footer: React.FC = () => {
    const [openSection, setOpenSection] = useState<string | null>(null);

    const sections: Section[] = [
        // {
        //     id: 'company',
        //     title: 'COMPANY',
        //     links: [
        //         { text: 'Careers', href: '#' },
        //         { text: 'Life at Protega', href: '#' },
        //         { text: 'News & Press', href: '#' },
        //     ]
        // },
        {
            id: 'customers',
            title: 'FOR CUSTOMERS',
            links: [
                { text: 'File a Claim', href: '/customer/chat' },
                { text: 'Login to Protega', href: '/customer-login' },
            ]
        },
        {
            id: 'merchants',
            title: 'FOR MERCHANTS',
            links: [
                { text: 'Our Platform', href: '/overview' },
                { text: 'Protection', href: '/protection' },
                { text: 'Shipping', href: '/shipping' },
                { text: 'Claims', href: '/claims' },
                { text: 'Fraud', href: '/fraud' },
                { text: 'Returns', href: '/returns' },
            ]
        },
        {
            id: 'resources',
            title: 'RESOURCES & MEDIA',
            links: [
                { text: 'Articles', href: '/articles' },
                { text: 'Case Studies', href: '/case-studies' },
                // { text: 'Marketing Toolkit', href: '#' },
                // { text: 'Developer Docs', href: '#' },
            ]
        },
        // {
        //     id: 'partners',
        //     title: 'PARTNERS',
        //     links: [
        //         { text: 'Become a Partner', href: '#' },
        //         { text: 'BigCommerce', href: '#' },
        //         { text: 'Shopify', href: '#' },
        //     ]
        // },
        {
            id: 'support',
            title: 'SUPPORT',
            links: [
                { text: 'Disclaimer', href: '/disclaimer' },
                { text: 'Terms of Service', href: '/terms' },
                { text: 'Privacy Policy', href: '/privacy-policy' },
            ]
        },
    ];

    const toggleSection = (id: string) => {
        setOpenSection(openSection === id ? null : id);
    };

    return (
        <footer className="tw-bg-black tw-py-2 tw-px-6 md:tw-px-12 tw-mt-12 md:tw-mt-20">

            <div className="tw-max-w-7xl tw-mx-auto">
                {/* Header with Logo and Social Icons */}
                <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-between tw-gap-4 tw-mb-12">
                    <img
                        src={Logo}
                        alt="Protega Logo"
                        className="tw-h-10 md:tw-h-12 lg:tw-h-14 tw-w-auto tw-block tw-object-contain"
                    />
                    <div className="tw-flex tw-space-x-4">
                        {/* <a href="#" className="tw-text-gray-400 hover:tw-text-[#00C5FB] tw-transition-colors">
                            <Facebook className="tw-w-5 tw-h-5" />
                        </a>
                        <a href="#" className="tw-text-gray-400 hover:tw-text-[#00C5FB] tw-transition-colors">
                            <Instagram className="tw-w-5 tw-h-5" />
                        </a> */}
                        <a href="https://www.linkedin.com/company/helloprotega/" target="_blank" className="tw-text-gray-400 hover:tw-text-[#00C5FB] tw-transition-colors">
                            <Linkedin className="tw-w-5 tw-h-5" />
                        </a>
                        {/* <a href="#" className="tw-text-gray-400 hover:tw-text-[#00C5FB] tw-transition-colors">
                            <Twitter className="tw-w-5 tw-h-5" />
                        </a> */}
                    </div> 
                </div>

                {/* Mobile Accordion */}
                <div className="md:tw-hidden">
                    {sections.map((section) => (
                        <div key={section.id} className="tw-border-b tw-border-gray-800">
                            <button
                                onClick={() => toggleSection(section.id)}
                                className="tw-w-full tw-py-4 tw-flex tw-justify-between tw-items-center tw-text-gray-400 tw-cursor-pointer hover:tw-text-[#00C5FB] tw-transition-colors"
                            >
                                <span className="tw-text-sm">{section.title}</span>
                                <Plus
                                    className="tw-w-4 tw-h-4 tw-transition-transform tw-duration-700"
                                    style={{
                                        transform: openSection === section.id ? 'rotate(135deg)' : 'rotate(0deg)',
                                    }}
                                />


                            </button>
                            <div
                                className={`tw-overflow-hidden tw-transition-all tw-duration-300 ${openSection === section.id ? 'tw-max-h-96 tw-pb-4' : 'tw-max-h-0'
                                    }`}
                            >
                                {section.links.map((link, idx) => (
                                    <Link
                                        key={idx}
                                        to={link.href}
                                        className="tw-block tw-py-2 tw-text-gray-300 hover:tw-text-white"
                                    >
                                        {link.text}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Desktop Layout */}
                <div className="tw-hidden md:tw-grid md:tw-grid-cols-3 tw-gap-8 tw-justify-center">
                    <div className="tw-space-y-8">
                        {sections.slice(0, 1).map((section) => (
                            <div key={section.id}>
                                <h3 className="tw-text-xs tw-text-gray-500 tw-mb-4">{section.title}</h3>
                                <div className="tw-space-y-3">
                                    {section.links.map((link, idx) => (
                                        <Link
                                            key={idx}
                                            to={link.href}
                                            className="tw-block tw-text-gray-300 hover:tw-text-[#00C5FB] tw-transition-colors"
                                        >
                                            {link.text}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="tw-space-y-8">
                        {sections.slice(1, 3).map((section) => (
                            <div key={section.id}>
                                <h3 className="tw-text-xs tw-text-gray-500 tw-mb-4">{section.title}</h3>
                                <div className="tw-space-y-3">
                                    {section.links.map((link, idx) => (
                                        <Link
                                            key={idx}
                                            to={link.href}
                                            className="tw-block tw-text-gray-300 hover:tw-text-[#00C5FB] tw-transition-colors"
                                        >
                                            {link.text}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="tw-space-y-8">
                        {sections.slice(3, 5).map((section) => (
                            <div key={section.id}>
                                <h3 className="tw-text-xs tw-text-gray-500 tw-mb-4">{section.title}</h3>
                                <div className="tw-space-y-3">
                                    {section.links.map((link, idx) => (
                                        <Link
                                            key={idx}
                                            to={link.href}
                                            className="tw-block tw-text-gray-300 hover:tw-text-[#00C5FB] tw-transition-colors"
                                        >
                                            {link.text}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* <div className="tw-space-y-8">
                        {sections.slice(5).map((section) => (
                            <div key={section.id}>
                                <h3 className="tw-text-xs tw-text-gray-500 tw-mb-4">{section.title}</h3>
                                <div className="tw-space-y-3">
                                    {section.links.map((link, idx) => (
                                        <a
                                            key={idx}
                                            href={link.href}
                                            className="tw-block tw-text-gray-300 hover:tw-text-[#00C5FB] tw-transition-colors"
                                        >
                                            {link.text}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        ))}
                         <div className="tw-space-y-4">
                            <img src="https://placehold.co/120x32" alt="Rating" className="tw-h-8" />
                            <img src="https://placehold.co/120x32" alt="BBB Rating" className="tw-h-8" />
                        </div> 
                    </div> */}
                </div>

                <div className="tw-mt-12 tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-justify-between tw-text-gray-500 tw-text-sm tw-gap-6">
                    {/* Left: Copyright */}
                    <div className="tw-text-center md:tw-text-left">
                        <p>© 2025 Protega.ai. All rights reserved.</p>
                        <p className="tw-mt-1 tw-text-xs tw-text-gray-600">Protega is a product of Embedmike India Private Limited.</p>
                    </div>

                    {/* Right: Vertical Support Links */}
                    <div className="tw-flex tw-flex-row tw-space-x-5 md:tw-items-end">
                        {sections
                            .find((s) => s.id === 'support')?.links.map((link, idx) => (
                                <a
                                    key={idx}
                                    href={link.href}
                                    className="tw-text-gray-500 hover:tw-text-[#00C5FB] tw-transition-colors"
                                >
                                    {link.text}
                                </a>
                            ))}
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default Footer;
